import { Badge } from "reactstrap";

// user_category_id >> { user_level_id }
// ทั่วไป: 1 >> { ปฏิบัติงาน: 1, ชำนาญงาน: 2, อาวุโส: 3, ทักษะพิเศษ: 4 }
// บริหาร: 2 >> { ต้น: 5, สูง: 6 }
// วิชาการ: 3 >> { ปฏิบัติการ: 7, ชำนาญการ: 8, ชำนาญการพิเศษ: 9, เชี่ยวชาญ:10, ทรงคุณวุฒิ: 11 }
// อำนวยการ: 4 >> { ต้น: 12, สูง: 13 }
// พนักงานขับรถ: 5 >> { ปฏิบัติงาน: 14 }

// น้ำหนักองค์ประกอบการประเมิน
// ปกติ: องค์ประกอบที่ 1 (ผลสัมฤทธิ์ของงาน) 70% / องค์ประกอบที่ 2 (พฤติกรรม) 30%
// เจ้าหน้าที่ที่ "ยังไม่ผ่านการทดลองงาน" (user_trial = 1): 50% / 50%
export const EVALUATE_WEIGHT_NORMAL = { first: "70", second: "30" };
export const EVALUATE_WEIGHT_TRIAL = { first: "50", second: "50" };

// รับได้ทั้ง "1" (string) และ 1 (number) จาก /api/users
export const isUserTrial = (user) => Number(user?.user_trial) === 1;

export const getEvaluateWeight = (user) =>
  isUserTrial(user) ? EVALUATE_WEIGHT_TRIAL : EVALUATE_WEIGHT_NORMAL;

export const checkExpectLevel = (userLevelId) => {

  if (userLevelId === 8 || userLevelId === 7 || userLevelId === 2 || userLevelId === 1 || userLevelId === 13 || userLevelId === 4) return "1"; // userLevelId 4 ยังไม่ได้ใช้ ใส่ไว้ก่อน

  if (userLevelId === 9 || userLevelId === 3 || userLevelId === 5) return "3";

  if (userLevelId === 11 || userLevelId === 10 || userLevelId === 6) return "5";

  return "0";
}

export const checkEvaluateScoreLevel = (score) => {
  if (!score) {
    return null
  }
  if (Math.floor(score) >= 90 && Math.floor(score) <= 100) {
    return "ดีเด่น"
  } else if (Math.floor(score) >= 80 && Math.floor(score) < 90) {
    return "ดีมาก"
  } else if (Math.floor(score) >= 70 && Math.floor(score) < 80) {
    return "ดี"
  } else if (Math.floor(score) >= 60 && Math.floor(score) < 70) {
    return "พอใช้"
  } else if (Math.floor(score) < 60) {
    return "ต้องปรับปรุง"
  }
}

export const getScoreLevelConfig = (i) => {
  const rawScore =
    i.total_score ??
    i.second_score ??
    i.first_score;

  if (rawScore == null) return null;

  const score = Math.floor(Number(rawScore));

  if (score >= 90) {
    return { color: "success", text: "ดีเด่น" };
  }
  if (score >= 80) {
    return { color: "primary", text: "ดีมาก" };
  }
  if (score >= 70) {
    return { color: "info", text: "ดี" };
  }
  if (score >= 60) {
    return { color: "warning", text: "พอใช้" };
  }

  return { color: "danger", text: "ต้องปรับปรุง" };
};

export const checkEvaluateStaus = (status) => {
  if (status === "0") {
    return "ไม่มีข้อมูล"
  } else if (status === "1") {
    return "บันทึกร่าง"
  } else if (status === "2") {
    return "รอรับการประเมิน"
  } else if (status === "3") {
    return "เสร็จสิ้นการประเมิน"
  } else if (status === "4") {
    return "ส่งกลับ"
  } else if (status === "5") {
    return "เข้าคณะกรรมการกลั่นกรอง"
  } else if (status === "9") {
    return "เข้าคณะกรรมการกลั่นกรอง"
  } else {
    return ""
  }
}

const getLatestVersionPerUser = (data, thisEvaluateUserId) => {
  const groupByUserId = new Map();

  data.forEach((item) => {
    const key = item.approve_user_id ?? thisEvaluateUserId;

    if (!groupByUserId.has(key)) {
      groupByUserId.set(key, []);
    }
    groupByUserId.get(key).push(item);
  });
  return groupByUserId;
};

export const filterLastVersionData = (data, thisEvaluateUserId) => {
    const filteredData = data.filter(item =>
      !(
        (item.approve_user_id === thisEvaluateUserId) ||
        (item.status_history === 0) ||
        (item.seq === 10) ||
        (item.first_score === null || item.second_score === null || item.total_score === null)
      )
    );

    // console.log(filteredData);

    const latestVersionPerUser = getLatestVersionPerUser(filteredData, thisEvaluateUserId)
    
    // const maxVersion = Math.max(
    //   ...filteredData.map(item => Number(item.version) || 0)
    // );
  
    // const latestByApproveUser = filteredData.filter(
    //   item => Number(item.version) === maxVersion
    // );
    let latestByApproveUser = []

    for (const [k,v] of latestVersionPerUser) {
      const maxVersion = Math.max(
        ...v.map(item => Number(item.version) || 0))
      const maxVersionPerUser = v.find((x) => x.version === maxVersion)
      latestByApproveUser.push(maxVersionPerUser)
    }

    // Object.values(
    //   filteredData.reduce((acc, item) => {
    //     const key = item.approve_user;
      
    //     if (!acc[key] || item.version > acc[key].version) {
    //       acc[key] = item;
    //     }
      
    //     return acc;
    //   }, {})
    // );

    return latestByApproveUser;
  }

  export const adjustApproveLevel = (evaluateApproveFlow, approveCheckpoint) => {
    let approveCheckpointIndex = evaluateApproveFlow?.findIndex(x => x.approve_user_id === approveCheckpoint)

    let sliceApproveFlow = evaluateApproveFlow?.slice(approveCheckpointIndex + 1)?.filter(x => x.assessor !== 1)
    return sliceApproveFlow
  }

  export const pickUserLevelEvaluateFlow = (sliceApproveFlow, priorityPositions) => {
    if (!(sliceApproveFlow && priorityPositions)) {
      return null
    }
    let result = null
    result = priorityPositions.map(pid =>
                 sliceApproveFlow.find(x => {
                     const pos = x.userApproveDataPosition;

                     // กรณีเป็น array
                     if (Array.isArray(pos)) {
                         return pos.some(p => p.position_id === pid && p.assign !== 1);
                     }

                     // กรณีเป็น object
                     return pos?.position_id === pid;
                 })
             )
             .find(Boolean);
    return result
  }

  export const checkMaxDate = (date, maxdate) => {
    if (date > maxdate) {
      return maxdate
    }
    return date
  }

  export const CheckApprovedEvaluate = (approveData, userApprove) => {
    if (approveData && userApprove) {
      let thisApprove = approveData
      const maxVersion = Math.max(
          ...thisApprove.map(item => Number(item.version) || 0)
      );
      thisApprove = thisApprove.filter(
          item => Number(item.version) === maxVersion
      );
      
      let approved = (thisApprove.find(x => Number(x.approve_user_id) === Number(userApprove) && x?.approve_status === "1"))
      if (approved) {
        return approved
      }
    }
    return null
  }

const EvaluateFormHeader = ({ mode }) => {
  if (mode === "EDIT") {// ว่างค่อยกลับมาเช็คว่าทำไมต้องแยก ตอนนี้ EDIT ใช้กับ INSERT ไปก่อน
    return (<thead
      className="table-light"
      style={{ whiteSpace: "nowrap" }}
    >
      <tr>
        <th rowSpan="3" className="text-center">
          ลำดับ
          <br />
          <br />
        </th>
        <th rowSpan="3" style={{ width: "500px" }}>
          ตัวชี้วัดผลงาน/
          <br />
          เกณฑ์การประเมิน
          <br />
          <br />
        </th>
        <th colSpan="5" className="text-center">
          คะแนนตามระดับค่าเป้าหมาย
        </th>
        <th rowSpan="3" className="text-center">
          คะแนน
          <br />
          (ก)
        </th>
        <th rowSpan="2" className="text-center">
          น้ำหนัก
          <br />
          ร้อยละ
          <br />
          (ข)
        </th>
        <th rowSpan="2" className="text-center">
          คะแนนรวม
          <br />
          (ค=กxข)
        </th>
        <th rowSpan="3" className="text-center">
          แนบเอกสาร
          <br />
          <span className="text-center text-danger" style={{ fontSize: 10 }}>(DOCX,PDF)<br /> ไม่เกิน 1 MB</span>
          <br />
        </th>
        <th rowSpan="3"></th>
      </tr>
      <tr>
        <th rowSpan="2" className="text-center">
          1
        </th>
        <th rowSpan="2" className="text-center">
          2
        </th>
        <th rowSpan="2" className="text-center">
          3
        </th>
        <th rowSpan="2" className="text-center">
          4
        </th>
        <th rowSpan="2" className="text-center">
          5
        </th>
      </tr>
    </thead>)
  }
  return (<thead
    className="table-light"
    style={{ whiteSpace: "nowrap" }}
  >
    <tr>
      <th rowSpan="3" className="text-center">
        ลำดับ
        <br />
        <br />
      </th>
      <th rowSpan="3" style={{ width: "0px" }}>
        ตัวชี้วัดผลงาน/
        <br />
        เกณฑ์การประเมิน
        <br />
        <br />
      </th>
      <th colSpan="5" className="text-center">
        คะแนนตามระดับค่าเป้าหมาย
      </th>
      <th rowSpan="3" className="text-center" style={{ minWidth: "80px" }}>
        คะแนน
        <br />
        (ก)
      </th>
      <th rowSpan="2" className="text-center" style={{ minWidth: "80px" }}>
        น้ำหนัก
        <br />
        ร้อยละ
        <br />
        (ข)
      </th>
      <th rowSpan="2" className="text-center">
        คะแนนรวม
        <br />
        (ค=กxข)
      </th>
      <th rowSpan="3" className="text-center">
        แนบเอกสาร
        <br />
        <span className="text-center text-danger" style={{ fontSize: 10 }}>(DOCX,PDF)<br /> ไม่เกิน 1 MB</span>
        <br />
      </th>
      {mode === "INSERT" && <th rowSpan="3" ></th>}
    </tr>
    <tr>
      <th rowSpan="2" className="text-center" style={{ minWidth: "65px" }}>
        1
      </th>
      <th rowSpan="2" className="text-center" style={{ minWidth: "65px" }}>
        2
      </th>
      <th rowSpan="2" className="text-center" style={{ minWidth: "65px" }}>
        3
      </th>
      <th rowSpan="2" className="text-center" style={{ minWidth: "65px" }}>
        4
      </th>
      <th rowSpan="2" className="text-center" style={{ minWidth: "65px" }}>
        5
      </th>
    </tr>
  </thead>)
}

export default EvaluateFormHeader